import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AirKeyWrapper } from '@/wrappers/AirKeyWrapper/AirKeyWrapper';
import { BrowserConfigParser } from '@components/BrowserConfigParser';
import { Template } from '@components/Template/Template';
import { Activation } from '@pages/Activation';
import { AlternativeWorkflow } from '@pages/AlternativeWorkflow';
import { CallCenter } from '@pages/CallCenter';
import { EnableNfc } from '@pages/EnableNfc';
import { Enrollments } from '@pages/Enrollments';
import { MerchantTransaction } from '@pages/MerchantTransaction';
import { NotFound } from '@pages/NotFound';
import { OneTap } from '@pages/OneTap';
import { TestingHarness } from '@pages/TestingHarness';
import { ThreeDS } from '@pages/ThreeDS';
import { isProd } from './utils/isProd';
import { ENABLE_NFC_PATH } from './utils/paymentHandlerBridge';

export default function Router() {
  return (
    <BrowserRouter>
      <Routes>
        {/* the new hotness */}
        <Route path="/ul" element={<AirKeyWrapper />}>
          <Route index element={<NotFound />} />
          <Route path="*" element={<NotFound />} />
          <Route
            path=":intentOwner/:workflow/:policyProcessId"
            element={<Template />}
          />
        </Route>

        {/* OneTap: sessionless card-tap-to-URL entry, own shell (no AirKeyWrapper) */}
        <Route path="/tap/:cardType" element={<OneTap />} />

        {/* NFC permission page: sessionless, outside the /3ds and /ul flows.
            The Payment Handler invoker opens this as a real top-level tab to get
            the Web NFC grant (a PH window can't prompt), then re-presents. */}
        <Route path={ENABLE_NFC_PATH} element={<EnableNfc />} />

        {/* kept for backwards compatibility */}
        <Route path="/" element={<BrowserConfigParser />}>
          <Route
            path="/3ds/:policyProcessId"
            element={
              <ThreeDS
                withWebNfcChecksCancelledMock={
                  import.meta.env.MODE !== 'production'
                }
              />
            }
          />
        </Route>

        {!isProd && (
          <Route path="/" element={<BrowserConfigParser />}>
            <Route
              path="/alternative/:policyProcessId"
              element={<AlternativeWorkflow />}
            />
            <Route
              path="/merchanttransaction/:policyProcessId"
              element={<MerchantTransaction />}
            />
            <Route
              path="/callcenter/:policyProcessId"
              element={<CallCenter />}
            />
            <Route
              path="/enrollments/:policyProcessId"
              element={<Enrollments />}
            />
            <Route
              path="/activation/:policyProcessId"
              element={
                //Display this only in local, dev and qa.
                import.meta.env.MODE !== 'production' ? (
                  <Activation isLoading={false} />
                ) : (
                  <NotFound />
                )
              }
            />

            <Route path="/testingHarness" element={<TestingHarness />} />
          </Route>
        )}
        <Route index element={<NotFound />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
